// src/api/reviewApi.js
import api from "../configs/axiosConfig";

// export async function submitReview(businessId, payload) {
//   const res = await api.post(`/home/reviews/${businessId}`, payload);
//   return res.data;
// }


export async function getMyReviews(params = {}) {
  // params: { status, page, page_size }
  const res = await api.get("/home/my_review", { params });
  return res.data; // { success, reviews, pagination }
}

export async function getReviewDailyStats(userId) {

  const res = await api.get(`/review/stats/daily/${userId}`);

  return res.data; // { success, status_level, daily_limit, today_count, remaining, can_review }
}

// NEW: which businesses user reviewed today
export async function getTodayReviewedTasks(userId) {
  const res = await api.get(`/review/today/${userId}`);
  return res.data; // { success, items: [ { business_id, status, ... } ] }
}


// daily stats (for home page)
export async function getDailyReviewStats() {
  const res = await api.get("/review/daily-stats");
  return res.data;
}

// random task (for ReviewPage)
export async function getRandomReviewTask(type) {
  const res = await api.get("/review/random-task", {
    params: { type },
  });
  return res.data;
}


export async function getReviewLimitsToday(userId) {

  const res = await api.get(`/review/limits/today/${userId}`);
  return res.data;
}

export async function getRandomBusinessTask(type, userId) {

  const res = await api.get("/review/random-business", {
    params: { type, user_id: userId },
  });
  return res.data;
}

export async function submitReview(payload) {

  const res = await api.post(`/review`, payload );
  return res.data;
}

